import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import {withStyles} from '@material-ui/core/styles';

import config from 'config';
import SearchBar from 'components/SearchBar';
import {handleChange, handleValueChange} from 'utils/ComponentUtilFunctions';
import {confirmActionRequested} from 'services/confirmAction/action';
import MemberConversationListManager from './chat-components/MemberConversationListManager';
import UserConversationListManager from './chat-components/UserConversationListManager';
import Conversation from './chat-components/Conversation';
import './index.css';

import {
    clearSelectedConversation as clearSelectedConversationFromStore,
    closeForwardDialog as closeForwardDialogAction,
    endConversationForOperatorRequested,
    forwardConversationRequested,
    initChatRequested,
    loadOlderMessagesRequested,
    openForwardDialog as openForwardDialogAction,
    selectConversationRequested,
    sendChatMessageRequested,
} from '../../../../services/chat/action';
import LoadingComponent from '../../../../assets/LoadingComponent';
import {getOperatorHotkeysConfig, getUserByPlatform} from "../../../../services/company/api";
import ConfirmModalFeedback from '../../../../components/ConfirmModalFeedback';
import WebChatTest from '../management/view/WebChatTest'
import Volume from "../../../../assets/images/volume.png";
import VolumeMute from "../../../../assets/images/volume-mute.png";
import {Slide} from "@material-ui/core";

const headerStyles = {
    button: {
        padding: '0 15px',
        background: 'transparent',
        color: '#A4ADC1',
        height: '100%',
        fontSize: '12px',
        fontWeight: 100,
        cursor: 'pointer',
    },
}
const styles = {
    drawerDocked: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '32px 0 32px 32px'
    },
    searchBar: {
        height: '50px',
        backgroundColor: 'rgb(235, 236, 240)',
        position: 'relative',
        margin: '20px',
        borderRadius: '20px'
    },
    drawerPaper: {
        borderRadius: '10px',
        width: '360px',
        position: 'relative',
        height: '100%',
        border: 0,
        boxShadow: '1px 5px 8px 0px rgba(24,62,153,0.2)',
    },

    drawerPaperMedia: {
        borderRadius: '10px',
        width: '400px',
        position: 'relative',
        height: '100%',
        border: 0,
        boxShadow: '1px 5px 8px 0px rgba(24,62,153,0.2)',
    },
};

class Chat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            temporaryDrawerOpen: false,
            contactsFilter: '',
            userData: {},
            filteredConversations: [],
            activeFilter: 'all',
            selectedClientId: '',
            hotkeys: [],
            isSoundEnabled: true
        };
        this.handleChange = handleChange.bind(this);
        this.handleValueChange = handleValueChange.bind(this);
    }

    componentDidMount() {
        const {company, user} = this.props;
        const features = company.tariff.features

        if (features.includes(config.features.HOTKEYS)) {
            Promise.all([
                getOperatorHotkeysConfig()
            ]).then(([hotkeys]) => {
                this.setState({
                    hotkeys: hotkeys
                });
            }).catch((error) => {
                console.error("Error loading data", error);
            });
        }

        const {initChat} = this.props;
        initChat();

        const stored = sessionStorage.getItem(`soundEnabled-${user.id}`);
        this.setState({isSoundEnabled: stored !== 'false'});
    }

    toggleTemporaryDrawer = () => {
        const {temporaryDrawerOpen} = this.state;
        this.setState({
            temporaryDrawerOpen: !temporaryDrawerOpen,
        });
    };

    selectConversation = (conversation) => {
        const {selectConversation} = this.props;
        this.setState({
            temporaryDrawerOpen: false,
        });
        selectConversation(conversation);
    };

    endConversationForOperatorClick = (conv) => {
        const {confirmAction, endConversationForOperator, company, conversation, user} = this.props;

        const users = company.members.filter(m => m.status === config.statusMap.enabled)
        confirmAction({
                content: <ConfirmModalFeedback tariff={company.tariff} users={users} isTicketDiv={false} user={user}
                                               conversation={conversation} conv={conv}
                                               endConversation={endConversationForOperator}/>
            }
        );
    };

    ticketClick = (conv) => {
        const {confirmAction, endConversationForOperator, company, conversation, user} = this.props;
        const users = company.members.filter(m => m.status === config.statusMap.enabled)
        confirmAction({
                content: <ConfirmModalFeedback tariff={company.tariff} users={users} isTicketDiv={true} user={user}
                                               conversation={conversation} conv={conv}
                                               endConversation={endConversationForOperator}/>
            }
        );
    };

    blockUserClick = (conv) => {
        const {confirmAction, endConversationForOperator, company, conversation, user} = this.props;
        confirmAction({
                content: <ConfirmModalFeedback tariff={company.tariff} isBlockUser={true} user={user}
                                               conversation={conversation} conv={conv}
                                               endConversation={endConversationForOperator}/>
            }
        );
    };

    filterMembersToForward = () => {
        const {conversation: {companyId}, company: {members}, user} = this.props;
        const {statusMap} = config;
        return members.filter(member =>
            member.id !== user.id && member.status === statusMap.enabled && (member.subCompanyIds.includes(companyId) || member.authorities[0] === config.rolesMap.admin || member.authorities[0] === config.rolesMap.owner));
    };

    componentWillMount() {
        const {user} = this.props;
        Promise.all([getUserByPlatform(user.id)])
            .then((results) => {
                this.setState({
                    userData: results[0]
                });
            });
    }

    componentWillReceiveProps(nextProps) {
        const {activeFilter} = this.state;

        let filteredConversations;
        if (activeFilter === 'all') {
            filteredConversations = nextProps.conversationsList;
        } else {
            filteredConversations = nextProps.conversationsList.filter(item => item.platform === activeFilter);
        }
        this.setState({filteredConversations});
    }

    toggleSound = () => {
        const {user} = this.props;
        const {isSoundEnabled} = this.state;
        const newValue = !isSoundEnabled;
        sessionStorage.setItem(`soundEnabled-${user.id}`, newValue);
        this.setState({isSoundEnabled: newValue});
    };

    render() {
        const {
            classes,
            conversation, sendChatMessage,
            forwardDialog, openForwardDialog, closeForwardDialog, forwardConversation,
            initializing, user, match: {params: {id}}, loadOlderMessages,
            clearSelectedConversationFromStore, company, confirmAction
        } = this.props;


        const tariff = company.tariff
        const {features} = tariff
        const filteredMembers = this.filterMembersToForward();

        if (initializing) {
            return (
                <LoadingComponent/>
            );
        }

        const {
            temporaryDrawerOpen,
            contactsFilter,
            userData,
            filteredConversations,
            hotkeys,
            isSoundEnabled
        } = this.state;


        function normalizeString(str) {
            if (typeof str !== 'string') return '';
            return str
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\s+/g, "")
                .trim();
        }

        let filteredConversationList;
        if (contactsFilter && contactsFilter.trim() !== '') {
            const search = normalizeString(contactsFilter);

            filteredConversationList = filteredConversations.filter((conv) => {
                const fullName = normalizeString(conv.userFirstName + conv.userLastName);
                const reverseName = normalizeString(conv.userLastName + conv.userFirstName);

                return fullName.includes(search) || reverseName.includes(search);
            });
        } else {
            filteredConversationList = filteredConversations;
        }

        let ConversationListManager;
        if (id === config.platformsMap.company && features.includes(config.features.INTERNAL_CHATS)) {
            const conversations = filteredConversationList.filter(curConversation => curConversation.platform === config.platformsMap.company);
            ConversationListManager = (
                <MemberConversationListManager
                    conversations={conversations}
                    selectConversation={this.selectConversation}
                    selectedConversation={conversation}
                />
            );
        } else {
            const incomingConversations = filteredConversationList.filter(curConversation => curConversation.platform !== config.platformsMap.company
                && curConversation.status === config.conversationStatuses.unManaged && (id === 'all' || curConversation.companyId === id));

            const processingConversations = filteredConversationList.filter(curConversation => curConversation.platform !== config.platformsMap.company
                && curConversation.status === config.conversationStatuses.operatorProcessing && (id === 'all' || curConversation.companyId === id));

            ConversationListManager = (
                <UserConversationListManager
                    endConversationForOperator={this.endConversationForOperatorClick}
                    forwardConversation={forwardConversation}
                    ticketClick={this.ticketClick}
                    blockUserClick={this.blockUserClick}
                    openForwardDialog={openForwardDialog}
                    incomingConversations={incomingConversations}
                    processingConversations={processingConversations}
                    selectConversation={this.selectConversation}
                    selectedConversation={conversation}
                    user={user}
                    userData={userData}
                    company={company}
                    loadOlderMessages={loadOlderMessages}
                    clearSelectedConversationFromStore={clearSelectedConversationFromStore}
                />
            );
        }

        const {subs: clients} = company;

        const drawer = (
            <div className="sidebar-content full-height flex-container-v" style={{overflow: 'hidden'}}>
                <div style={{
                    fontSize: '17px',
                    fontWeight: 'bold',
                    display: 'flex',
                    gap: '10px',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'rgb(4, 62, 92)',
                    height: '50px',
                    marginTop: '15px',
                    marginBottom: '15px',
                    padding: '25px'
                }}>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '13px',
                        borderRadius: '10px',
                        width: '100%',
                    }}>
                        <SearchBar
                            wrapperStyles={{
                                backgroundColor: 'rgb(235, 236, 240)',
                                width: '300px',
                                height: '35px',
                                border: 0,
                                borderRadius: '10px'
                            }}
                            handleSearch={this.handleValueChange('contactsFilter')}
                            searchString={contactsFilter}
                            id="chat-contact-search-input"
                        />
                        <div style={{backgroundColor: '#043e5c', padding: '5px', borderRadius: '20px'}}>
                            <button
                                type="button"
                                onClick={this.toggleSound}
                                style={{
                                    ...headerStyles.button,
                                    padding: '0 10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: 'none',
                                    background: 'transparent',
                                }}
                            >
                                <img
                                    src={isSoundEnabled ? Volume : VolumeMute}
                                    alt={isSoundEnabled ? "Sound on" : "Sound off"}
                                    style={{width: '14px', height: '14px'}}
                                />
                            </button>
                        </div>
                    </div>
                </div>

                {ConversationListManager}
            </div>
        );

        return (
            <div className="chat-panel">
                <Hidden smDown>
                    <Drawer
                        variant="permanent"
                        anchor="left"
                        open
                        classes={{
                            docked: classes.drawerDocked,
                            paper: classes.drawerPaper,
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden mdUp>
                    <Slide direction="right" in={true} mountOnEnter unmountOnExit>
                        <Drawer
                            variant="temporary"
                            open={temporaryDrawerOpen}
                            onClose={this.toggleTemporaryDrawer}
                            classes={{
                                docked: classes.drawerDocked,
                                paper: classes.drawerPaperMedia,
                            }}
                            ModalProps={{
                                keepMounted: true,
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Slide>
                </Hidden>
                <div style={{display: 'flex', height: '100%', width: '100%', padding: '32px', flexDirection: 'column'}}>
                    <div className="conversation-wrapper" style={{height: 'calc(100vh - 365px)'}}>
                        <Conversation
                            selectConversation={this.selectConversation}
                            confirmAction={confirmAction}
                            company={company}
                            conversation={conversation}
                            sendChatMessage={sendChatMessage}
                            endConversationForOperator={this.endConversationForOperatorClick}
                            ticketClick={this.ticketClick}
                            blockUserClick={this.blockUserClick}
                            openForwardDialog={openForwardDialog}
                            openContactList={this.toggleTemporaryDrawer}
                            loadOlderMessages={loadOlderMessages}
                            user={user}
                            onUnMount={clearSelectedConversationFromStore}
                            hasBackButton
                            filteredMembers={filteredMembers}
                            forwardDialog={forwardDialog}
                            close={closeForwardDialog}
                            forwardConversation={forwardConversation}
                            tariff={company.tariff}
                            hotkeys={hotkeys}
                        />
                    </div>
                </div>

                {this.state.selectedClientId && this.state.selectedClientId.disabled !== true && (
                    <WebChatTest key={this.state.selectedClientId} companyId={this.state.selectedClientId}/>
                )}
            </div>
        );
    }
}


Chat.propTypes = {
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    conversation: PropTypes.object.isRequired,
    conversationsList: PropTypes.array.isRequired,
    initializing: PropTypes.bool.isRequired,
    initChat: PropTypes.func.isRequired,
    selectConversation: PropTypes.func.isRequired,
    sendChatMessage: PropTypes.func.isRequired,
    forwardDialog: PropTypes.object.isRequired,
    openForwardDialog: PropTypes.func.isRequired,
    closeForwardDialog: PropTypes.func.isRequired,
    forwardConversation: PropTypes.func.isRequired,
    loadOlderMessages: PropTypes.func.isRequired,
    clearSelectedConversationFromStore: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    user: state.user,
    chat: state.chat,
    company: state.company,
    conversationsList: state.chat.conversationsList,
    conversation: state.chat.conversation,
    forwardDialog: state.chat.forwardDialog,
    initializing: state.chat.initializing,
});

const mapDispatchToProps = dispatch => ({
    initChat: () => {
        dispatch(initChatRequested());
    },
    selectConversation: (conversation) => {
        dispatch(selectConversationRequested(conversation));
    },
    sendChatMessage: (message, commentMessage) => {
        dispatch(sendChatMessageRequested(message, commentMessage));
    },
    endConversationForOperator: (silentMod, conv) => {
        dispatch(endConversationForOperatorRequested(silentMod, conv));
    },
    openForwardDialog: () => {
        dispatch(openForwardDialogAction());
    },
    closeForwardDialog: () => {
        dispatch(closeForwardDialogAction());
    },
    forwardConversation: (operatorContact, silentMod, conv) => {
        dispatch(forwardConversationRequested(operatorContact, silentMod, conv));
    },
    loadOlderMessages: () => {
        dispatch(loadOlderMessagesRequested());
    },
    clearSelectedConversationFromStore: () => {
        dispatch(clearSelectedConversationFromStore());
    },
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Chat));



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/index.jsx